<template>
  <app-form-select
    :datas="paymentGateways"
    :disabled="disabled"
    :errorMessage="errorMessage"
    :serverMessage="serverMessage"
    :loading="loading"
    :showLabel="showLabel"
    :allowFilter="allowFilter"
    v-model="checkedValue"
    v-on:retry="getPaymentGateways()"
    v-on:valueSelected="onValueSelected"
  />
</template>

<script>
export default {
  props: {
    labelText: {
      type: String,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    allowFilter: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Object,
      default: () => {},
    },
    country_id: {
      type: Number,
      default: 0,
    },
  },
  watch: {

    paymentGateways(paymentGateways) {
      if (this.$lodash.isEmpty(paymentGateways)) {
        this.onValueSelected(null);
      }
    },
  },
  computed: {
    checkedValue: {
      get() {
        if (this.$lodash.isEmpty(this.paymentGateways)) {
          return {};
        }
        return this.modelValue ?? [];
      },
      set(value) {
        this.onValueSelected(value);
      },
    },

    paymentGateways() {
      return this.$store.getters["referenceStore/paymentGateways"];
    },

    loading() {
      return this.$store.getters["referenceStore/loading"];
    },

    serverMessage() {
      return this.$store.getters["referenceStore/message"] ?? "";
    },
  },

  async mounted() {
    this.getPaymentGateways();
  },

  methods: {
    async getPaymentGateways() {
      this.$store.commit("referenceStore/resetState");
      this.$store.dispatch("referenceStore/getPaymentGateways");
    },

    onValueSelected(value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>


